import React, { ReactNode } from 'react';
import { flex, getCssVarColorWithOpacity } from '@fabric-ui/theme';
import { emptyObject } from '@fabric-ui/utils';
import { Box, type SxProps, type Theme } from '@mui/material';
import { AvTooltip } from '../AvTooltip';

export interface LogoBaseProps {
  src: string;
  width?: number;
  height?: number;
  children?: ReactNode;
  transparent?: boolean;
  title?: string;
  style?: SxProps<Theme>;
  alt?: string;
  onError?: React.ReactEventHandler<HTMLImageElement>;
}

export function LogoBase({
  src,
  width = 24,
  height,
  children,
  transparent = false,
  title,
  style = emptyObject,
  alt,
  onError,
}: LogoBaseProps) {
  const sx = {
    ...flex.center,
    width,
    aspectRatio: '1 / 1',
    backgroundColor: transparent ? 'inherit' : getCssVarColorWithOpacity('var(--color-content-immutable-lightGrey)', 0.28, '#ffffff'),
    borderRadius: '100%',
    flexShrink: 0,
    '> img': {
      objectFit: 'contain',
      width: width * 0.7,
      height: height ? height * 0.7 : width * 0.7,
    },
    ...style,
  };

  const logo = <Box sx={sx}>{children || <img src={src} alt={alt} onError={onError} />}</Box>;
  return title ? <AvTooltip title={title}>{logo}</AvTooltip> : logo;
}
